import { API_URL } from 'constants';

export const EMPLOYEE_MANUAL_ASK = `${API_URL}/api/v1/employeemanual/ask-manual`;

export const NOTIFICATION_HUB_URL = `${API_URL}/notificationHub`;
